import { formatDateTime, formatMoney, useLocale, useTranslation } from '@multaqa/i18n'
import { useMemo } from 'react'

/**
 * The texts and formatters the shared import views (`@multaqa/ui`) take as
 * props, built from the `companies.imports` keys both apps share.
 */
export function useImportViewText() {
  const { t } = useTranslation()
  const { locale } = useLocale()
  return useMemo(
    () => ({
      report: {
        summary: t('companies.imports.summary'),
        sheet: t('companies.imports.sheet'),
        created: t('companies.imports.created'),
        updated: t('companies.imports.updated'),
        unchanged: t('companies.imports.unchanged'),
        errors: t('companies.imports.errors'),
        problems: t('companies.imports.problems'),
        row: t('companies.imports.row'),
        column: t('companies.imports.column'),
        problem: t('companies.imports.problem'),
        wholeRow: t('companies.imports.wholeRow'),
        warnings: t('companies.imports.warnings'),
        warning: t('companies.imports.warning'),
        warningsHint: t('companies.imports.warningsHint'),
        changes: t('companies.imports.changes'),
        changesHint: t('companies.imports.changesHint'),
        totals: t('companies.imports.totals'),
      },
      history: {
        title: t('companies.imports.history'),
        empty: t('companies.imports.historyEmpty'),
        emptyDescription: t('companies.imports.historyEmptyDescription'),
        uploadedAt: t('companies.imports.uploadedAt'),
        file: t('companies.imports.file'),
        uploadedBy: t('companies.imports.uploadedBy'),
        status: t('companies.imports.statusLabel'),
        result: t('companies.imports.result'),
        open: t('companies.imports.open'),
      },
      formatProblemsMore: (shown: number, total: number) =>
        t('companies.imports.problemsMore', { shown, total }),
      formatResult: ({ created, updated }: { created: number; updated: number }) =>
        t('companies.imports.resultCounts', { created, updated }),
      formatDate: (value: string) => formatDateTime(new Date(value), locale),
      formatAmount: (amount: string, currency: string) => formatMoney(amount, currency, locale),
      doorLabel: (door: string) => t(`companies.imports.door.${door}`, { defaultValue: door }),
      statusLabel: (status: string) =>
        t(`companies.imports.status.${status}`, { defaultValue: status }),
    }),
    [t, locale],
  )
}
